import ApplicationAdapter from './application';

export default class PropertyDeviceAdapter extends ApplicationAdapter {
  urlForUpdateRecord(id, _modelName, snapshot) {
    return this.buildURL('config', id, snapshot).replace('v3', 'v2');
  }
}
